import React from 'react';

import ActionLink from '../../builder/ActionLink';

const BracketsButton = (props) => {
	const promotion = props?.promotion ?? false;
	if(promotion === false) return null;

	const is_builder = props?.is_builder ?? false;

	const brackets_enabled = (promotion.brackets_enabled != undefined && promotion.brackets_enabled == '1') ? true : false;
	if(brackets_enabled === false) return null;
	const single_bracket = props?.bracket_id ?? false;

	const label = props?.children ?? (promotion?.custom_labels?.view_brackets_button ?? "Brackets");
	const target = null;
	
	const in_widget = props?.in_widget ?? false;
	let link = props?.link ?? ((single_bracket !== false) ? `/single_brackets/${promotion.id}/${single_bracket}` : `/brackets/${promotion.id}`);
	if(in_widget) link += '/?fromwidget=1';

	const icon = props?.icon ?? 'knk-brackets';

	return (
		<ActionLink
			icon={icon}
			_href={(!is_builder) ? link : null}
			_target={target}
			_class={{ other:'brackets_btn' }}
		>{label}</ActionLink>
	)
};

export default BracketsButton;